import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "card-section-wrapper" };
const _hoisted_2 = { class: "contents-title-text mb-1 ml-1" };
const _hoisted_3 = { class: "thead-tr" };
const _hoisted_4 = ["colspan"];
import { computed, watch, ref, } from 'vue';
import vuexStore from '@/vuex-store';
// import CardSection from '@/components/Common/CardSection.vue';
import { userPermissionSettingTableHeader as tableHeader } from '@/constants/userPermissionSetting/userPermissionSettingTableHeader';
import UserPermissionSettingRadioBtn from '@/views/Dialog/UserPermissionSettingDialog/UserPermissionSettingRadioBtn.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserPermissionSettingDialogTable',
    setup(__props) {
        const isSorted = ref(false);
        const getterUserPermissionList = computed(() => vuexStore.getters['userPermissionSettingDialog/getterUserPermissionList']);
        const filteredList = ref([]);
        watch(() => getterUserPermissionList.value, (value) => {
            if (value.length === 0) {
                return;
            }
            if (isSorted.value) {
                return;
            }
            // ㄱㄴㄷㄹ 순으로 1회 수정
            filteredList.value = value.sort((a, b) => a.depth1Name.localeCompare(b.depth1Name, 'ko-KR'));
            isSorted.value = true;
        });
        /** 최초 로드 시 모든 상위 권한은 펼쳐져 있다. */
        const expanded = ref([]);
        const getterExpandedCodeList = computed(() => vuexStore.getters['userPermissionSettingDialog/getterExpandedCodeList']);
        watch(() => getterExpandedCodeList.value, (value) => {
            if (value.length === 0) {
                return;
            }
            expanded.value = value;
        });
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, (depth1, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: depth1.depth1Name + index
                    }, [
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(depth1.depth1Name), 1 /* TEXT */),
                        _createCommentVNode(" 상위 권한 테이블 "),
                        _createVNode(_component_v_data_table, {
                            "data-cy": "user-permission-setting-dialog-table",
                            class: "user-permission-table-wrapper brg-table",
                            expanded: expanded.value,
                            "onUpdate:expanded": _cache[0] || (_cache[0] = ($event) => ((expanded).value = $event)),
                            "show-expand": "",
                            "hide-default-footer": "",
                            headers: _unref(tableHeader),
                            items: depth1.depth2,
                            "items-per-page": -1,
                            "items-length": -1,
                            "item-value": "item.code",
                            density: "comfortable"
                        }, {
                            headers: _withCtx(({ columns }) => [
                                _createElementVNode("tr", _hoisted_3, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (c, k) => {
                                        return (_openBlock(), _createElementBlock("th", {
                                            key: k,
                                            style: _normalizeStyle(`width: ${c.width}px`),
                                            class: "text-center"
                                        }, _toDisplayString(c.title), 5 /* TEXT, STYLE */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]),
                            [`item.item.isAuthorized`]: _withCtx(({ item }) => [
                                _createVNode(UserPermissionSettingRadioBtn, {
                                    item: item.item
                                }, null, 8 /* PROPS */, ["item"])
                            ]),
                            "expanded-row": _withCtx(({ item }) => [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                        class: "depth2-td-wrapper",
                                        colspan: _unref(tableHeader).length
                                    }, [
                                        _createCommentVNode(" 하위 권한 테이블 "),
                                        _createVNode(_component_v_data_table, {
                                            class: "depth2-data-table",
                                            hover: "",
                                            "hide-default-header": "",
                                            "hide-default-footer": "",
                                            headers: _unref(tableHeader),
                                            items: item.children,
                                            density: "comfortable"
                                        }, {
                                            [`item.item.isAuthorized`]: _withCtx(({ item: children }) => [
                                                _createVNode(UserPermissionSettingRadioBtn, {
                                                    item: children.item
                                                }, null, 8 /* PROPS */, ["item"])
                                            ]),
                                            [`item.data-table-expand`]: _withCtx(() => _cache[1] || (_cache[1] = [])),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "items"])
                                    ], 8 /* PROPS */, _hoisted_4)
                                ])
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["expanded", "headers", "items"])
                    ]));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
